const middleware = {}

middleware['block-pages'] = require('../middleware/block-pages.js')
middleware['block-pages'] = middleware['block-pages'].default || middleware['block-pages']

export default middleware
